import { formatDate } from '@angular/common';
import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AbstractCrudComponent } from '../../component/abstract-crud.component';
import { ConfirmationDialogComponent } from '../../dialogs/confirmation-dialog/confirmation-dialog.component';
import { Feriado } from '../feriado';
import { FeriadoService } from '../feriado.service';

@Component({
  selector: 'app-feriado-list',
  templateUrl: './feriado-list.component.html',
  styleUrls: ['./feriado-list.component.css']
})
export class FeriadoListComponent extends AbstractCrudComponent {

  displayedColumns: string[] = ['dataFeriado', 'descricaoFeriado', 'details'];

  constructor(private feriadoService: FeriadoService, router: Router,
    dialog: MatDialog) {

    super(router, dialog);

  }

  ngOnInit() {

    this.reloadData();

    super.ngOnInit();
  }

  onSubmit() {
    this.reloadData();
  }

  reloadData() {


    this.feriadoService.listar()
      .subscribe(data => {
        // console.log(data)

        const listaFeriados: Array<Feriado> = [];

        data.forEach((element: any) => {
          listaFeriados.push(Object.assign(new Feriado(), element));
        });

        this.data = listaFeriados;

        this.configurarDataSource();
      }, error => {
        console.log(error);
      });
  }

  confirmDelete(id: Date) {
    const confirmDialog = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Confirmação de exclusão',
        message: 'Deseja realmente remover essa informação ?'
      }
    });
    confirmDialog.afterClosed().subscribe(result => {
      if (result === true) {
        this.delete(id);
      }
    });
  }

  delete(id: Date) {

    let dataFeriado:string = formatDate(id, 'yyyy-MM-ddTHH:mm:ss', 'en');

    this.feriadoService.remover(dataFeriado)
      .subscribe(
        data => {
          // console.log(data);
          this.reloadData();
        },
        error => {
          console.log(error);
        });
  }

  add() {
    this.router.navigate(['manterFeriado']);
  }

  details(feriado: Feriado) {
    this.router.navigate(['manterFeriado'], {
      state: {
        feriado: feriado,
        isUpdate: 'N'
      }
    });
  }
}
